import React, {
    useEffect,
    useRef
} from "react";
import { 
    useHistory, 
    useParams
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { 
    alterModal,
    clearNextPage
} from "../redux/index";
import { modals } from "./modals";
import styled from "styled-components";
import nykreditIcons from '../images/icons/Nykredit_Icons.svg';

const OuterWrapper = styled.div`
    ${props => props.theme.mediaQueries.medium}{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        background: rgba(79, 82, 93, 0.6);
        z-index: 1;
    }
`

const Wrapper = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    background: #F7F7F5;

    ${props => props.theme.mediaQueries.medium}{
        position: relative;
        left: auto;
        top: auto;
        height: auto;
        overflow-y: hidden;
        width: 640px;
        min-height: 807px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 91px;
        box-shadow: 13px 15px 20px 0px rgba(78, 78, 78, 0.25);
    }
`

const CloseWrapper = styled.div`
    margin-left: auto;
    margin-right: auto;
    width: 335px;
    position: relative;
    margin-top: 26px;
    height: 30px;

    ${props => props.theme.mediaQueries.medium}{
        margin-top: 47px;
        height: 62px;
        width: 540px;
    }
`

const Close = styled.svg`
    background-image: url(${nykreditIcons}#Close);
    height: 20px;
    width: 20px;
    position: absolute;
    right: 0;
    cursor: pointer;
`

const Content = styled.div`
    width: 335px;
    margin-left: auto;
    margin-right: auto;

    ${props => props.theme.mediaQueries.medium}{
        width: 540px;
    }
`

const Modal = () => {
    const dispatch = useDispatch();
    const locationSearch = useSelector(state => state.queryStringReducer.search)
    const history = useHistory();
    const { id } = useParams();
    const ref = useRef(null);

    useEffect(() => {
        dispatch(alterModal());
    }, [])

    useEffect(() => {
        ref.current.scrollTop = 0;
    })

    const renderContent = () => {
        for(let key in modals) {
            if (id === key) {
                return modals[key]
            }
        }
    }

    const close = () => {
        dispatch(alterModal());
        dispatch(clearNextPage());

        const locationSearch = sessionStorage.getItem('locationSearch')
        history.push(locationSearch ? `/${locationSearch}` : '/');
    }

    return (
        <OuterWrapper onClick={close}>
            <Wrapper
                ref={ref}
                onClick={e => e.stopPropagation()}
            >
                <CloseWrapper>
                    <Close onClick={close} />
                </CloseWrapper>

                <Content>
                    {renderContent()} 
                </Content>
  
            </Wrapper>
        </OuterWrapper>
    )
}

export default Modal;